/**
 *
 *  ? url pada submenu menggunakana naming routes,
 *  ? jadi tidak perlu dibuat format url lengkap
 */
export default [
  {
    icon: "BookIcon",
    menu: "Laporan Absensi",
    url: "tendik-laporan-absensi",
  },
  {
    icon: "CreditCardIcon",
    menu: "Slip Gaji",
    url: "tendik-slip-gaji",
  },
  {
    icon: "CheckIcon",
    menu: "Kuisioner",
    url: "tendik-kuisioner",
  },
  {
    icon: "UsersIcon",
    menu: "Kerjasama",
    url: "tendik-kerjasama",
  },
];
